'use strict';
import {mapPropsStream} from 'recompose';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {IonKeyboardAttach} from '../../../_libs/reactionic/src/components/ionKeyboardAttach';
import {createDimensionObserver} from '../../../core-utilities/react-utils';
import {ModalContentView} from './ModalContentView';


export const StreamedComponent = (props$) => {
  const keyboardHeight$ = props$
    .map(props => props.keyboardHeight)
    .distinctUntilChanged();

  const propsStyle$ = props$
    .map(props => props.style)
    .distinctUntilChanged();

  const {
    handler: setDivRef,
    stream: dimensions$,
  } = createDimensionObserver(props$, {
    height: true,
    width: false,
  });

  const style$ = Observable
    .combineLatest(
      propsStyle$,
      keyboardHeight$,
      dimensions$,
      (style, keyboardHeight, dimensions) => ({
        style,
        availableHeight: dimensions.availableHeight,
        windowHeight: dimensions.windowHeight,
        keyboardHeight,
      })
    )
    .map(({style, availableHeight, windowHeight, keyboardHeight}) => {
      if (!keyboardHeight || !windowHeight || !availableHeight) {
        return style;
      } else {
        return {
          // merge style from props, if any. Ignore changes to max-height.
          ...(style || {}),
          // Keep this synchronized with ModalContent.scss.
          // TODO: check props.hasHeader and props.hasFooter, then use the corresponding constants here.
          // eslint-disable-next-line max-len
          maxHeight: `${windowHeight - 44 - 57 - keyboardHeight}px`,
        };
      }
    })
    .takeUntil(props$.last());

  return props$
    .combineLatest(
      style$,
      (props, style) => ({
        ...props,
        style,
        setDivRef,
      }));
};

export const ModalContentComponent = IonKeyboardAttach(mapPropsStream(StreamedComponent)(ModalContentView));



// WEBPACK FOOTER //
// ./src/js/components/modals/ModalContent/ModalContentComponent.js